export default "__VITE_ASSET__5KDlGZ1N__"